import { useCallback, useMemo, useState } from 'react';
import { productTypeOptions } from './useCreateEditCaseForm';
import { UserData } from '@/api';

export const CloneCaseSidebarFormDataFieldsName = {
  CaseReference: 'CaseReference',
  AssignedUser: 'AssignedUser',
  DueDate: 'DueDate',
  Urgent: 'Urgent',
  PaginationProduct: 'PaginationProduct'
} as const;

export interface CloneCaseSidebarFormData {
  [CloneCaseSidebarFormDataFieldsName.CaseReference]: string;
  [CloneCaseSidebarFormDataFieldsName.AssignedUser]: UserData | null;
  [CloneCaseSidebarFormDataFieldsName.DueDate]: Date;
  [CloneCaseSidebarFormDataFieldsName.Urgent]: boolean;
  [CloneCaseSidebarFormDataFieldsName.PaginationProduct]: (typeof productTypeOptions)[number];
}

type FormDataValueTypes = CloneCaseSidebarFormData[keyof CloneCaseSidebarFormData];

const initialFormState: CloneCaseSidebarFormData = {
  [CloneCaseSidebarFormDataFieldsName.CaseReference]: '',
  [CloneCaseSidebarFormDataFieldsName.AssignedUser]: null,
  [CloneCaseSidebarFormDataFieldsName.DueDate]: new Date(),
  [CloneCaseSidebarFormDataFieldsName.Urgent]: false,
  [CloneCaseSidebarFormDataFieldsName.PaginationProduct]: productTypeOptions[0]
};

export const useCloneCaseForm = () => {
  const [formData, setFormData] = useState<CloneCaseSidebarFormData>(initialFormState);

  const handleValueChange = useCallback((fieldName: keyof CloneCaseSidebarFormData, value: FormDataValueTypes) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value
    }));
  }, []);

  const resetForm = useCallback(() => {
    setFormData(initialFormState);
  }, []);

  const canSubmit = useMemo(() => {
    return Boolean(
      formData[CloneCaseSidebarFormDataFieldsName.CaseReference] &&
        formData[CloneCaseSidebarFormDataFieldsName.DueDate] &&
        formData[CloneCaseSidebarFormDataFieldsName.PaginationProduct]
    );
  }, [formData]);

  return { formData, setFormData, handleValueChange, resetForm, canSubmit };
};
